module.exports = __webpack_public_path__ + "static/media/6.ad6cb792.jpg";